import { useEffect, useState } from "react";
import { Images } from "../../assets";

const WelcomePopup = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const hasVisited = localStorage.getItem("hasVisited");
    if (hasVisited !== "true") {
      setShowPopup(true);
      localStorage.setItem("hasVisited", "false");
    }
  }, []);

  useEffect(() => {
    if (showPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showPopup]);

  const closePopup = () => setShowPopup(false);

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="relative flex flex-col lg:flex-row max-w-full sm:max-w-[70vw] md:max-w-[60vw] lg:max-w-[50vw] h-fit max-h-[90vh] p-5 lg:p-0 overflow-x-hidden">
        <button
          onClick={closePopup}
          className="absolute top-3 lg:-top-3 right-8 lg:right-3 text-light lg:text-dark font-bold text-[50px] rotate-45"
        >
          +
        </button>
        <div className="flex flex-col gap-5 bg-dark text-light w-full lg:w-1/2 p-5 lg:p-7 rounded-t-[20px] lg:rounded-tr-none lg:rounded-l-[20px]">
          <h2 className="text-xl lg:text-2xl uppercase font-semibold">
            Commandez sur :
          </h2>
          <a
            href="https://www.ubereats.com/ch-fr/store/cavallo-bianco/j1r_EkFYSMmf7rl3LYe95w"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-light rounded-[20px] w-full px-10 py-7 cursor-pointer"
          >
            <img src={Images.UBER_EATS} alt="Logo Uber Eats" />
          </a>
          <a
            href="https://www.just-eat.ch/fr/menu/cavallo-bianco"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-light rounded-[20px] w-full px-10 py-7 cursor-pointer"
          >
            <img src={Images.JUST_EAT} alt="Logo Uber Eats" />
          </a>
        </div>

        <div className="flex flex-col gap-5 bg-light text-dark w-full lg:w-1/2 px-5 lg:px-7 pt-7 pb-3 rounded-b-[20px] lg:rounded-bl-none lg:rounded-r-[20px]">
          <h2 className="text-2xl uppercase font-semibold">Appelez-nous :</h2>
          <div className="flex flex-col items-center bg-dark text-light w-full px-10 py-7 rounded-[20px]">
            <p className="text-xl whitespace-nowrap">Et bénéficiez de</p>
            <p className="text-[70px] lg:text-[100px]">-10%*</p>
            <p className="text-xl whitespace-nowrap">
              sur les plats à l'emporter
            </p>
            <p className="italic whitespace-nowrap">
              (menus à la carte et pizzas)
            </p>
          </div>
          <p className="text-xs self-end">*à aller chercher sur place</p>
        </div>
      </div>
    </div>
  );
};

export default WelcomePopup;
